<div class="row">
  @if (label) {
    <div [ngClass]="{'col-md-2': !specialRowSpanningInputs && bigInput, 'col-md-4': specialRowSpanningInputs || !bigInput}" >
      <label>@if (mandatory) {
        <span style="color: red">*</span>
      }{{label + endingCharacter()}}</label>
    </div>
  }
  <div [ngClass]="{ 'col-md-12': !label, 
                    'col-md-10': label && (!specialRowSpanningInputs && bigInput), 
                    'col-md-8':  label && (specialRowSpanningInputs || !bigInput)}">

    @if (((fieldLevelSecurity === 'U' || fieldLevelSecurity === 'A') && editable) || (fieldLevelSecurity === undefined && editable)) {
      <mat-form-field style="width: 100%"
        [ngClass]="{'tableInput': tableInput}">
        <textarea [rows]="rows" matInput [(ngModel)]="value" [name]="name" [maxLength]="maxLength"
        (blur)="offFocus(); tooltip.hide()" [matTooltip]="toolTips" (focus)="tooltip.show()" #tooltip="matTooltip"></textarea>
      </mat-form-field>
    }
    @if ((!editable && (fieldLevelSecurity === 'U' || fieldLevelSecurity === 'A')) || (fieldLevelSecurity === undefined && !editable) || fieldLevelSecurity === 'I') {
      <mat-form-field style="width: 100%"
        [ngClass]="{'tableInput': tableInput}">
        <textarea [rows]="rows" matInput [ngModel]="value" [name]="name" [maxLength]="maxLength" [disabled]="true"
        (blur)="offFocus(); tooltip.hide()" [matTooltip]="toolTips" (focus)="tooltip.show()" #tooltip="matTooltip"></textarea>
      </mat-form-field>
    }
    @if (fieldLevelSecurity === 'N') {
      <mat-form-field style="width: 100%" [ngClass]="{'tableInput': tableInput}">
        <textarea [rows]="rows" matInput [name]="name" [maxLength]="maxLength" [disabled]="true"></textarea>
      </mat-form-field>
    }
    @for (message of validatorMessages; track message) {
      <div class="inputValidationMessage" [ngClass]="{'inputValidationMessageTable' : tableInput}">
        {{message}}
      </div>
    }
  </div>
</div>
